<template>
  <table>
    <tr>
      <th>
        公道を自力で自走できますか？
        <span class="must">必須</span>
        <div class="supplement">
          事故車、整備不良車（バッテリー上がりも含む）、
          冬期の積雪時スタッドレス未装着、夏場のエアコン不良の場合は自走できません
        </div>
      </th>
      <td>
        <div>
          <validation-provider
            name="is_self_run"
            v-slot="{ errors }"
            rules="required"
          >
            <b-form-radio-group
              ref="is_self_run"
              v-model="conditions.is_self_run"
              :state="errors.length ? false : null"
              :options="yesNoFumeiListDesc"
            >
              <b-form-invalid-feedback :state="!errors.length">
                <span class="border-red">{{ errors[0] }}</span>
              </b-form-invalid-feedback>
            </b-form-radio-group>
          </validation-provider>
        </div>
        <div v-if="conditions.is_self_run === 0">
          <div class="mt-1">
            <validation-provider
              name="is_self_run_detail"
              v-slot="{ errors }"
              rules="required"
            >
              <div>
                <strong>自走できない理由を選択してください</strong>
              </div>
              <b-form-radio-group
                ref="is_self_run_detail"
                v-model="conditions.is_self_run_detail"
                :options="carConditionNotSelfRunForReasonList"
              >
                <b-form-invalid-feedback :state="!errors.length">
                  <span class="border-red">{{ errors[0] }}</span>
                </b-form-invalid-feedback>
              </b-form-radio-group>
            </validation-provider>
          </div>
          <div
            v-if="conditions.is_self_run_detail === 99"
            class="row mt-1"
          >
            <span class="mt-2 ml-3">
              <strong>その他詳細</strong>
            </span>
            <div class="col-md-10">
              <validation-provider
                name="is_self_run_detail_other"
                v-slot="{ errors }"
                rules="required|max:100|char"
              >
                <b-form-input-custom
                  ref="is_self_run_detail_other"
                  v-model="
                    conditions.is_self_run_detail_other
                  "
                  maxlength="100"
                  :errors="errors"
                />
                <b-form-invalid-feedback>
                  <span class="border-red">{{ errors[0] }}</span>
                </b-form-invalid-feedback>
              </validation-provider>
            </div>
          </div>
          <div
            v-if="
              [2, 3].includes(
                conditions.is_self_run_detail
              )
            "
          >
            <div class="mt-1">
              <validation-provider
                name="is_roll_tire"
                v-slot="{ errors }"
                rules="required"
              >
                <div>
                  <strong>タイヤは転がりますか？</strong>
                </div>
                <b-form-radio-group
                  ref="is_roll_tire"
                  v-model="conditions.is_roll_tire"
                  :state="errors.length ? false : null"
                  :options="yesNoListDesc"
                >
                  <b-form-invalid-feedback :state="!errors.length">
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </b-form-radio-group>
              </validation-provider>
            </div>
            <div class="mt-1">
              <validation-provider
                name="is_run_engine"
                v-slot="{ errors }"
                rules="required"
              >
                <div>
                  <strong>エンジンはかかりますか？</strong>
                </div>
                <b-form-radio-group
                  ref="is_run_engine"
                  v-model="conditions.is_run_engine"
                  :state="errors.length ? false : null"
                  :options="yesNoListDesc"
                >
                  <b-form-invalid-feedback :state="!errors.length">
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </b-form-radio-group>
              </validation-provider>
            </div>
          </div>
        </div>
        <div class="f-size-12 red mt-1">
          ※その他、車両不具合がある場合、輸送が出来兼ねることがある為、車両の状態はご依頼時にご申告・ご相談下さい。
        </div>
        <div v-if="conditions.is_self_run === 1">
          <div class="mt-1">
            <validation-provider
              name="is_studless"
              v-slot="{ errors }"
              rules="required"
            >
              <div>
                <strong>(冬期)スタッドレスタイヤ装着済です</strong>
              </div>
              <b-form-radio-group
                ref="is_studless"
                v-model="conditions.is_studless"
                :state="errors.length ? false : null"
                :options="yesNoFumeiListDesc"
              >
                <b-form-invalid-feedback :state="!errors.length">
                  <span class="border-red">{{ errors[0] }}</span>
                </b-form-invalid-feedback>
              </b-form-radio-group>
            </validation-provider>
          </div>
          <div class="mt-1">
            <validation-provider
              name="is_run_air_conditioner"
              v-slot="{ errors }"
              rules="required"
            >
              <div>
                <strong>
                  (夏期)エアコン故障・不良車両ではありません
                </strong>
              </div>
              <b-form-radio-group
                ref="is_run_air_conditioner"
                v-model="
                  conditions.is_run_air_conditioner
                "
                :state="errors.length ? false : null"
                :options="yesNoFumeiListDesc"
              >
                <b-form-invalid-feedback :state="!errors.length">
                  <span class="border-red">{{ errors[0] }}</span>
                </b-form-invalid-feedback>
              </b-form-radio-group>
            </validation-provider>
          </div>
          <div class="f-size-12 red mt-1">
            ※冬期の積雪時スタッドレス未装着、夏期のエアコン不良の場合は自走できません。
            <br />
            陸送ルートや地域によっては、自走区間がある為、日程や料金が変更になる可能性がございます。
          </div>
        </div>
      </td>
    </tr>
    <tr>
      <th>
        車両改造有無
        <span class="must">必須</span>
        <div class="supplement">
          ルーフキャリア、リフトアップ、ローダウンまたはエアロ付車両
          （地面からの距離
          15cm以下の車両）、オーバーフェンダー付車両
          特殊架装車等は、改造車となります
        </div>
      </th>
      <td>
        <div>
          <validation-provider
            name="is_custom"
            v-slot="{ errors }"
            rules="required"
          >
            <b-form-radio-group
              ref="is_custom"
              v-model="conditions.is_custom"
              :state="errors.length ? false : null"
              :options="isCarCustomList"
            >
              <b-form-invalid-feedback :state="!errors.length">
                <span class="border-red">{{ errors[0] }}</span>
              </b-form-invalid-feedback>
            </b-form-radio-group>
          </validation-provider>
        </div>
        <div v-if="conditions.is_custom === 1">
          <div class="mt-1">
            <validation-provider
              name="is_custom_details"
              v-slot="{ errors }"
              :rules="{
                required:
                  isCustomDetails.length ===
                  0,
              }"
            >
              <div>
                <strong>
                  該当するものにチェックを入れてください
                </strong>
              </div>
              <b-form-group v-slot="{ ariaDescribedby }">
                <b-form-checkbox-group
                  ref="is_custom_details"
                  v-model="conditions.is_custom_details"
                  size="sm"
                  :options="carCustomList"
                  :state="
                    errors.length &&
                    !isCustomDetails.length
                      ? false
                      : null
                  "
                  :aria-describedby="ariaDescribedby"
                >
                  <b-form-invalid-feedback
                    :state="
                      !(
                        errors.length &&
                        !isCustomDetails
                          .length
                      )
                    "
                  >
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </b-form-checkbox-group>
              </b-form-group>
            </validation-provider>
            <div
              v-if="
                isCustomDetails.find(
                  (value) => [2, 3].includes(value)
                )
              "
              class="row mt-1"
            >
              <span class="mt-2 ml-3">
                <strong>最低地上高</strong>
              </span>
              <div class="col-md-4">
                <validation-provider
                  name="minimum_height"
                  v-slot="{ errors }"
                  rules="required|max:100|char"
                >
                  <b-form-input-custom
                    ref="minimum_height"
                    v-model="conditions.minimum_height"
                    maxlength="100"
                    :errors="errors"
                  />
                  <b-form-invalid-feedback>
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </validation-provider>
              </div>
              <span class="mt-2 ml-3">
                <strong>cm</strong>
              </span>
            </div>
            <div
              v-if="
                isCustomDetails.includes(5)
              "
              class="row mt-1"
            >
              <span class="mt-2 ml-3">
                <strong>アップしたインチ数</strong>
              </span>
              <div class="col-md-4">
                <validation-provider
                  name="inch_up"
                  v-slot="{ errors }"
                  rules="required|max:100|char"
                >
                  <b-form-input-custom
                    ref="inch_up"
                    v-model="conditions.inch_up"
                    maxlength="100"
                    :errors="errors"
                  />
                  <b-form-invalid-feedback>
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </validation-provider>
              </div>
            </div>
            <div
              v-if="
                isCustomDetails.includes(99)
              "
              class="row mt-1"
            >
              <span class="mt-2 ml-3">
                <strong>その他詳細</strong>
              </span>
              <div class="col-md-10">
                <validation-provider
                  name="is_custom_detail_other"
                  v-slot="{ errors }"
                  rules="required|max:100|char"
                >
                  <b-form-input-custom
                    ref="is_custom_detail_other"
                    v-model="
                      conditions.is_custom_detail_other
                    "
                    maxlength="100"
                    :errors="errors"
                  />
                  <b-form-invalid-feedback>
                    <span class="border-red">{{ errors[0] }}</span>
                  </b-form-invalid-feedback>
                </validation-provider>
              </div>
            </div>
          </div>
        </div>
      </td>
    </tr>
    <tr>
      <th>
        高額車ですか？
        <span class="must">必須</span>
        <div class="supplement">
          高額車とは車両価格500万以上の車両です
        </div>
      </th>
      <td>
        <div>
          <validation-provider
            name="is_expensive"
            v-slot="{ errors }"
            rules="required"
          >
            <b-form-radio-group
              ref="is_expensive"
              v-model="conditions.is_expensive"
              :state="errors.length ? false : null"
              :options="isExpensiveCarList"
            >
              <b-form-invalid-feedback :state="!errors.length">
                <span class="border-red">{{ errors[0] }}</span>
              </b-form-invalid-feedback>
            </b-form-radio-group>
          </validation-provider>
        </div>
        <div
          v-if="conditions.is_expensive === 1"
          class="row mt-1"
        >
          <span class="mt-2 ml-3">
            <strong>価格</strong>
          </span>
          <div class="col-md-4">
            <validation-provider
              name="price"
              v-slot="{ errors }"
              rules="required|max:100|char"
            >
              <b-form-input-custom
                ref="price"
                v-model="conditions.price"
                maxlength="100"
                :errors="errors"
              />
              <b-form-invalid-feedback>
                <span class="border-red">{{ errors[0] }}</span>
              </b-form-invalid-feedback>
            </validation-provider>
          </div>
          <span class="mt-2">
            <strong>万円</strong>
          </span>
        </div>
      </td>
    </tr>
    <tr>
      <th>
        旧車ですか？
        <span class="must">必須</span>
        <div class="supplement">
          旧車とは製造から30年以上経っている車輛です
        </div>
      </th>
      <td>
        <div>
          <validation-provider
            name="is_classic"
            v-slot="{ errors }"
            rules="required"
          >
            <b-form-radio-group
              ref="is_classic"
              v-model="conditions.is_classic"
              :state="errors.length ? false : null"
              :options="isClassicCarList"
            >
              <b-form-invalid-feedback :state="!errors.length">
                <span class="border-red">{{ errors[0] }}</span>
              </b-form-invalid-feedback>
            </b-form-radio-group>
          </validation-provider>
        </div>
        <div
          v-if="conditions.is_classic === 1"
          class="row mt-1"
        >
          <span class="mt-2 ml-3">
            <strong>年式</strong>
          </span>
          <div class="col-md-4">
            <validation-provider
              name="model_year"
              v-slot="{ errors }"
              rules="required|max:100|char"
            >
              <b-form-input-custom
                ref="model_year"
                v-model="conditions.model_year"
                maxlength="100"
                placeholder="平成元年 / 1989年"
                :errors="errors"
              />
              <b-form-invalid-feedback>
                <span class="border-red">{{ errors[0] }}</span>
              </b-form-invalid-feedback>
            </validation-provider>
          </div>
        </div>
      </td>
    </tr>
    <tr>
      <th>
        車両燃料を選択してください
        <span class="must">必須</span>
        <div class="supplement">
          ※車両燃料の種類によっては輸送方法に制限がございます。
          選択が誤っていた場合、輸送方法の変更により、
          追加料金や納期遅延などが発生する場合がございますので、
          該当燃料を正確にご選択ください。
        </div>
      </th>
      <td>
        <div>
          <validation-provider
            name="fuel_type"
            v-slot="{ errors }"
            rules="required"
          >
            <b-form-radio-group
              ref="fuel_type"
              v-model="conditions.fuel_type"
              :state="errors.length ? false : null"
              :options="carFuelList"
            >
              <b-form-invalid-feedback :state="!errors.length">
                <span class="border-red">{{ errors[0] }}</span>
              </b-form-invalid-feedback>
            </b-form-radio-group>
          </validation-provider>
        </div>
        <div
          v-if="[2, 3, 4].includes(conditions.fuel_type)"
          class="f-size-12 red mt-1"
        >
          ※輸送方法の変更により追加料金や納期遅延などが発生する場合がございます。
        </div>
      </td>
    </tr>
  </table>
</template>

<script>
import BFormInputCustom from '@/components/form/input'
import Mixin from '../mixin/Mixin'
export default {
  name: 'SyaryoConditions',
  mixins: [Mixin],
  components: {
    BFormInputCustom,
  },
  props: {
    conditions: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getRefs() {
      return this.$refs
    }
  },
  computed: {
    /** 改造・架装 */
    isCustomDetails() {
      return this.conditions.is_custom_details || []
    },
  }
}
</script>

<style lang="sass" scoped>
@import '../../assets/css/logico2'
.supplement
  color: #fac4dc
  font-size: 12px
  margin-top: 0.25rem
table
  th
    background: $baseBlueColor
    color: #fff
    width: 32%
    padding: 1.5%
  td
    width: 68%
    background: #fff
    padding: 10px
</style>


// WEBPACK FOOTER //
// src/components/order/SyaryoConditions.vue